<mat-form-field appearance="outline" class="auto-chips-field">
  <mat-chip-grid #chipGrid aria-label="Item selection">
    @for (value of visibleChips; track value.id || value.name) {
      <mat-chip-row (removed)="remove(value)" [class.external-speaker-chip]="value.isExternal">
        {{ displayName(value) }}
        @if (isItemRemovable(value)) {
          <button matChipRemove [attr.aria-label]="'remove ' + displayName(value)">
            <mat-icon>cancel</mat-icon>
          </button>
        }
      </mat-chip-row>
    }

    @if (!isExpanded && extraCount > 0) {
      <mat-chip-row class="expand-chip" disabled>+{{ extraCount }}</mat-chip-row>
    }
  </mat-chip-grid>

  <input
    [placeholder]="selectedItems.length === 0 ? (placeholder | translate) : ''"
    #searchInput
    #autocompleteTrigger="matAutocompleteTrigger"
    [formControl]="searchCtrl"
    [matAutocomplete]="auto"
    [matChipInputFor]="chipGrid"
    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
    (matChipInputTokenEnd)="add($event)"
  />

  <!-- Spinner -->
  @if (isLoading) {
    <mat-progress-spinner
      matSuffix
      diameter="24"
      mode="indeterminate"
      color="primary"
      strokeWidth="3"
      class="spinner-suffix"
    ></mat-progress-spinner>
  }

  <!-- Expand icon -->
  @if (!isLoading) {
    <mat-icon matSuffix (click)="handleExpand(autocompleteTrigger, $event)" style="cursor: pointer">
      {{ isExpanded ? 'expand_less' : 'expand_more' }}
    </mat-icon>
  }

  <mat-autocomplete
    #auto="matAutocomplete"
    (optionSelected)="selected($event)"
    autoActiveFirstOption
    panelClass="chips-autocomplete-panel"
  >
    @for (option of filteredOptions | async; track option.id ?? option.name) {
      <mat-option [value]="option" [disabled]="isAlreadySelected(option)">
        <mat-checkbox color="primary" [checked]="isAlreadySelected(option)">{{ option.name }}</mat-checkbox>
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
